import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

const featured = SERVICES.slice(0, 7);

const spans = [
  "md:col-span-6 md:row-span-2",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-4",
  "md:col-span-2",
];

export default function BentoServices() {
  return (
    <section className="bg-soft-grey py-24 md:py-32" data-testid="bento-services">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
            <div>
              <span className="text-royal text-xs font-semibold tracking-[0.3em] uppercase">Our Services</span>
              <h2 className="font-display text-4xl md:text-5xl font-extrabold text-navy-deep mt-3">Complete Waterproofing Solutions</h2>
            </div>
            <Link to="/services" className="text-royal font-semibold flex items-center gap-1 hover:gap-2 transition-all">
              View all 20 services <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>

        <Stagger className="grid grid-cols-1 md:grid-cols-12 md:auto-rows-[190px] gap-4">
          {featured.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Droplets;
            const big = i === 0;
            return (
              <StaggerItem key={s.slug} className={spans[i] || "md:col-span-3"}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="group relative block h-full min-h-[190px] rounded-lg overflow-hidden border border-slate-200 bg-navy-deep"
                >
                  <img src={s.image} alt={`${s.title} in Jaipur`} className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/50 to-transparent" />
                  <div className="relative h-full p-5 flex flex-col justify-between">
                    <div className="h-10 w-10 rounded-md glass flex items-center justify-center">
                      <Icon className="h-5 w-5 text-sky" />
                    </div>
                    <div>
                      <h3 className={`font-display font-extrabold text-white ${big ? "text-2xl md:text-3xl" : "text-lg"}`}>{s.title}</h3>
                      {big && <p className="text-slate-300 text-sm mt-2 max-w-md">{s.short}</p>}
                      <span className="inline-flex items-center gap-1 text-sky text-sm font-semibold mt-2 opacity-0 group-hover:opacity-100 transition-opacity">Explore <ArrowUpRight className="h-4 w-4" /></span>
                    </div>
                  </div>
                </Link>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
